<div
  class="flex w-full mb-4 px-1.5"
  [class.justify-end]="isCustomer()"
  [class.justify-start]="!isCustomer()"
>
  <div class="max-w-[82%] flex flex-col gap-1">
    @if (!isCustomer() && message().author_name) {
      <span class="text-sm text-surface-500 dark:text-surface-400 px-1">
        @if (isAi()) {
          <i class="fa-solid fa-robot mr-1" aria-hidden="true"></i>
        }
        {{ message().author_name }}
      </span>
    }

    <!-- bubble + tail -->
    <div class="relative">
      <div
        class="rounded-lg px-3 py-2 whitespace-pre-wrap [overflow-wrap:anywhere]"
        [class.bg-primary]="isCustomer()"
        [class.text-primary-contrast]="isCustomer()"
        [class.bg-surface-100]="!isCustomer()"
        [class.dark:bg-surface-700]="!isCustomer()"
        [class.border]="!isCustomer()"
        [class.border-surface-200]="!isCustomer()"
        [class.dark:border-surface-700]="!isCustomer()"
        [class.opacity-60]="message().optimisticStatus === 'pending'"
      >
        @for (part of parts(); track $index) {
          @if (part.href) {
            <a
              [href]="part.href"
              target="_blank"
              rel="noopener"
              class="underline"
              >{{ part.text }}</a
            >
          } @else {
            <span>{{ part.text }}</span>
          }
        }
      </div>

      <!-- dialog tail: a rotated square at the bottom outer corner. Kept inside
           the bubble's horizontal box (right-0 / left-0, not negative) so it is
           not clipped by the thread's overflow-y-auto scroll container. -->
      <span
        class="absolute bottom-[-4px] w-2.5 h-2.5 rotate-315"
        [class.right-[8px]]="isCustomer()"
        [class.bg-primary]="isCustomer()"
        [class.left-[8px]]="!isCustomer()"
        [class.bg-surface-100]="!isCustomer()"
        [class.dark:bg-surface-700]="!isCustomer()"
        [class.border-b]="!isCustomer()"
        [class.border-l]="!isCustomer()"
        [class.border-surface-200]="!isCustomer()"
        [class.dark:border-surface-700]="!isCustomer()"
        [class.opacity-60]="message().optimisticStatus === 'pending'"
        aria-hidden="true"
      ></span>
    </div>

    <div
      class="flex items-center gap-2 mt-2 px-1 text-sm text-surface-500 dark:text-surface-400"
      [class.justify-end]="isCustomer()"
    >
      <span>{{ message().created_at | date: 'short' }}</span>
      @if (message().optimisticStatus === 'pending') {
        <i class="fa-solid fa-clock" aria-hidden="true"></i>
      }
      @if (message().optimisticStatus === 'failed') {
        <span class="text-red-600 dark:text-red-400">
          {{ 'support.chat.sendFailed' | translate }}
        </span>
        <button
          type="button"
          class="text-primary underline"
          (click)="retry.emit(message().localId)"
        >
          {{ 'support.chat.retry' | translate }}
        </button>
      }
    </div>
  </div>
</div>
